import router from '@/router'
import store from '@/state/store'
import { isTrackvisionDevice } from './device'
import { Helper } from '@/mixin/helper'

const CALL_DRIVER_EXCLUDED_DEVICE_TYPES = ['jc']
const CALL_DRIVER_ACCESS_SCOPES = [
  'b3f-two-way-communication:read',
  'b3f-two-way-communication-all-module:read',
]

export { isTrackvisionDevice } from './device'

export function isCanCallDriver(deviceType) {
  return !CALL_DRIVER_EXCLUDED_DEVICE_TYPES.includes(deviceType) && isTrackvisionDevice(deviceType)
}

export function getAlertActionIcons({ alert, deviceCode, hasAccessAll, track }) {
  const deviceType = Helper.methods.getDeviceType(deviceCode)
  const trackvisionDevice = isTrackvisionDevice(deviceType)
  const callActive = isCallActive(alert)
  let isDangerVariant = false

  return [
    {
      icon: 'mc-fa icon-outline_file-text',
      label: 'Detail Notifikasi',
      visible: true,
      isDangerVariant,
      disabled: false,
      action: () => openDetailNotification(alert),
    },
    {
      icon: 'mc-fa icon-outline_live-view',
      label: 'Live View Monitoring',
      visible: true,
      isDangerVariant,
      disabled: false,
      action: () => openLiveview(alert, track),
    },
    {
      icon: 'mc-fa icon-outline_pin-history',
      label: 'global.object.tripHistory',
      visible: true,
      isDangerVariant,
      disabled: false,
      action: () => redirectToTripHistory(alert),
    },
    {
      icon: 'mc-fa icon-outline_videorecord',
      label: 'menuitems.liveStreaming.text',
      visible:
        hasAccessAll(['b3h-new-trackvision-menu:read', 'b3j-trackvision-live-streaming:read']) &&
        trackvisionDevice,
      isDangerVariant,
      disabled: false,
      action: () => openLiveStream(alert),
    },
    {
      icon: 'mc-fa icon-outline_video-history',
      label: 'menuitems.videoHistory.text',
      visible:
        hasAccessAll(['b3h-new-trackvision-menu:read', 'b3k-trackvision-video-history:read']) &&
        trackvisionDevice,
      isDangerVariant,
      disabled: false,
      action: () => openVideoHistory(alert),
    },
    {
      icon: `mc-fa ${callActive ? 'icon-outline_phone-off' : 'icon-outline_phone'}`,
      label: callActive ? 'trackVideo.endCall' : 'notification.action.callDriver',
      visible: hasAccessAll(CALL_DRIVER_ACCESS_SCOPES) && isCanCallDriver(deviceType),
      isDangerVariant: callActive,
      disabled: !canStartCall(alert),
      action: () => (callActive ? clickEndCall(alert, track) : clickCall(alert, track)),
    },
  ].filter((item) => item.visible)
}

function openVideoHistory(alert) {
  const vehicleId = alert?.childVehicleId || alert?.vehicleId
  const createdOn = alert?.createdOn
  const alertCreatedOn = new Date(createdOn)
  const now = new Date()
  const startTime = new Date(alertCreatedOn.getTime() - 10 * 60 * 1000)
  const endTime = new Date(Math.min(alertCreatedOn.getTime() + 10 * 60 * 1000, now.getTime()))
  if (!vehicleId) return
  window.open(
    `${window.location.protocol}//${window.location.host}/video-history/?${new URLSearchParams({
      vehicleId,
      startTime: startTime.toISOString(),
      endTime: endTime.toISOString(),
    }).toString()}`,
    '_blank'
  )
}

function openLiveStream(alert) {
  const vehicleId = alert?.childVehicleId || alert?.vehicleId
  if (!vehicleId) return
  window.open(
    `${window.location.protocol}//${window.location.host}/live-streaming/?vehicleId=${vehicleId}`,
    '_blank'
  )
}

function openDetailNotification(alert) {
  const alertId = alert?.rawAlertId
  if (!alertId) return

  const isSameRoute =
    router.currentRoute.name === 'Notification Detail' && router.currentRoute.params.id == alertId

  if (isSameRoute) return

  const resolved = router.resolve({
    name: 'Notification Detail',
    params: { id: alertId },
  })

  window.open(resolved.href, '_blank')
}

function buildLiveviewUrl(params) {
  const base = `${window.location.protocol}//${window.location.host}/liveview-2/`
  const query = new URLSearchParams(params).toString()
  return `${base}?${query}`
}

function openLiveview(alert, track) {
  const language = localStorage.getItem('language')
  track('Click Lacak Kendaraan on Notification Preview', {
    'license-plate': alert.licensePlate,
    'notification-name':
      language === 'en' ? alert.alert.descriptionEng : alert.alert.descriptionIdn,
  })
  window.open(buildLiveviewUrl({ type: 'vehicle', vehicleId: alert.vehicleId }), '_blank')
}

function redirectToTripHistory(alert) {
  const vehicleId = alert?.vehicleId
  if (!vehicleId) return
  window.open(buildLiveviewUrl({ type: 'history', vehicleId, navSource: 'vehicle' }), '_blank')
}

function getCallVehicleId(alert) {
  return alert?.callState?.vehicleIdVoip
}

function isCallActive(alert) {
  const vehicleId = getCallVehicleId(alert)
  if (!vehicleId) return false

  return store.getters['voip/vehicleIdsCallActive'].includes(vehicleId)
}

function canStartCall(alert) {
  const vehicleId = getCallVehicleId(alert)
  if (!vehicleId) return false
  if (!store.getters['identity/hasAccessAll'](CALL_DRIVER_ACCESS_SCOPES)) return false
  if (store.state.voip.isBroadcastActive) return false
  const activeVehicleIds = store.getters['voip/vehicleIdsCallActive']
  return activeVehicleIds.length < store.state.voip.maxCall || activeVehicleIds.includes(vehicleId)
}

function clickCall(alert, track) {
  if (!canStartCall(alert)) return

  track('Alert Center - VoIP Admin make a call', {
    entryPoint: 'Alert Center',
    alertCode: alert.alertCode,
    alertDescription: alert.alert.descriptionIdn,
  })

  store.dispatch('voip/startNewCall', {
    dataNewCall: {
      vehicleId: alert.callState.vehicleIdVoip,
      licensePlate: alert.vehicle?.licensePlate,
      driver: alert.driver?.fullname ?? null,
      imei: alert.callState.imeiVoip,
      deviceType: alert.callState.deviceType,
      entryPoint: 'alertCenter',
    },
  })
}

function clickEndCall(alert, track) {
  const vehicleId = getCallVehicleId(alert)
  if (!vehicleId) return

  track('Alert Center - VoIP End Call', {
    entryPoint: 'Alert Center',
  })

  store.dispatch('voip/endCall', {
    vehicleId,
  })
}
